// Live client-side scan for an unfilled INSERT* placeholder token left in an
// editable draft/note field — a proactive, purely visual warning, the same
// idea as restrictedInfoCheck.js applied to placeholders instead of PII (see
// that file's own header comment). Token-agnostic on purpose: there are
// ~12 different hand-rolled INSERT* tokens across pipeline.js/actions.js
// (INSERTWARRANTY, INSERTLABELLINK, INSERTEDD, INSERTDATE, INSERTADDRESS,
// etc.), each resolved by its own flow-specific logic server-side — this
// doesn't know or care which one it is, it just flags whatever text is still
// sitting there unresolved once it reaches the agent. [AGENT_FIRST_NAME]-style
// bracket placeholders are a different, already-handled convention (see
// SuggestionPanel.jsx) — the INSERT[A-Z0-9]+ pattern naturally excludes them.
//
// findUnresolvedPlaceholders (@cxhub/shared) is the single source of truth
// for the pattern itself — also used server-side (send-approved-reply.js's
// real send-time refusal, this warning's actual backstop) — so the two can
// never disagree about what counts as unresolved. Re-exported under this
// file's own established name for every existing caller in this file.
export { findUnresolvedPlaceholders as findUnfilledPlaceholders } from '@cxhub/shared'
import { findUnresolvedPlaceholders, mentionsSignifyd } from '@cxhub/shared'

// "Signifyd" is internal only (2026-10-19): the same warning, and the same
// disabled Send, in every box this check runs on; the server refuses the send
// with the same mentionsSignifyd() (@cxhub/shared). "fraud" and "declined"
// are not flagged.
export const INTERNAL_ONLY_WARNING = 'Warning: This reply mentions Signifyd, which is internal only. Remove it before sending.'

// Wraps the found tokens in the warning sentence, and the internal-only
// warning. Returns null when nothing was found (the render-gate case).
export function unfilledPlaceholderWarning(text) {
  const found = findUnresolvedPlaceholders(text)
  const parts = []
  if (found.length) parts.push(`Warning: This draft still contains an unfilled placeholder (${found.join(', ')}) — replace it with the real value before sending.`)
  if (mentionsSignifyd(text)) parts.push(INTERNAL_ONLY_WARNING)
  return parts.length ? parts.join(' ') : null
}

// The placeholder part alone (2026-10-30, docs/decisions/2026-10-30-send-
// warns-not-blocks.md): Send's stop. The Signifyd mention is a Send warning
// there (sendWarnings.js), not a stop; Process all keeps the combined check.
export function placeholderOnlyWarning(text) {
  const found = findUnresolvedPlaceholders(text)
  return found.length ? `Warning: This draft still contains an unfilled placeholder (${found.join(', ')}) — replace it with the real value before sending.` : null
}
